module.exports = __webpack_public_path__ + "static/media/edit_pen_selected.1613674d.svg";